const quotesModel = vm => ({
  title: vm.$gettext('Quotes'),
  endpoint: 'quotes',
  allowNew: true,
  allowDelete: true,
  allowBulk: true,
  countrize: 'country_iso_from',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true
    },
    {
      key: 'area_id_from',
      label: vm.$gettext('Origin Area'),
      type: 'select',
      options: 'areas',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: true,
      sortable: true,
      required: true,
      description: vm.$gettext('Origin Area for this Quote'),
      default: null
    },
    {
      key: 'area_id_to',
      label: vm.$gettext('Destination Area'),
      type: 'select',
      options: 'areas',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: true,
      sortable: true,
      required: true,
      description: vm.$gettext('Destination Area for this Quote'),
      default: null
    },
    {
      key: 'region_id_from',
      label: vm.$gettext('Origin Region'),
      type: 'select',
      options: 'regions',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: true,
      sortable: true,
      required: false,
      description: vm.$gettext('Origin Region this quote is for'),
      default: null
    },
    {
      key: 'region_id_to',
      label: vm.$gettext('Destination Region'),
      type: 'select',
      options: 'regions',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: true,
      sortable: true,
      required: false,
      description: vm.$gettext('Destination Region this quote is for'),
      default: null
    },
    {
      key: 'platform_id',
      label: vm.$gettext('Platform'),
      sortable: true,
      editable: true
    },
    {
      key: 'size_id',
      label: vm.$gettext('Size'),
      sortable: true,
      editable: true
    },
    {
      key: 'shipping_type_id',
      label: vm.$gettext('Type'),
      sortable: true,
      editable: true
    },
    {
      key: 'company_id',
      label: vm.$gettext('Companies Count'),
      sortable: false,
      editable: false,
      formatter: (value, key, item) => {
        return item.quote_companies.length > 0 ? item.quote_companies.length : 0
      }
    }
  ],
  filters: [
    'id',
    'name',
    'area_id_from',
    'area_id_to',
    'region_id_from',
    'region_id_to',
    'vehicle_type_id',
    'shipping_type_id',
    'company_id'
  ]
})

export default quotesModel
